var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7562 6.70768H14.5895C15.0498 6.70768 15.4229 7.08077 15.4229 7.54102V15.8743C15.4229 16.3346 15.0498 16.7077 14.5895 16.7077H1.25618C0.795952 16.7077 0.422852 16.3346 0.422852 15.8743V7.54102C0.422852 7.08077 0.795952 6.70768 1.25618 6.70768H2.08952V5.87435C2.08952 2.65269 4.70119 0.0410156 7.92285 0.0410156C11.1445 0.0410156 13.7562 2.65269 13.7562 5.87435V6.70768ZM2.08952 8.37435V15.041H13.7562V8.37435H2.08952ZM7.08952 10.041H8.75618V13.3743H7.08952V10.041ZM12.0895 6.70768V5.87435C12.0895 3.57317 10.224 1.70768 7.92285 1.70768C5.62167 1.70768 3.75618 3.57317 3.75618 5.87435V6.70768H12.0895Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.11fb2e7cb851c9fe29dbc1e5e13ea2e9.svg";
export { ForwardRef as ReactComponent };